// Target Module Index
// 목표 관리 모듈 통합

import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import targetKpi, { targetKpiSaga } from './targetKpi';
import userTarget, { userTargetSaga } from './userTarget';

// 사가 통합
export function* targetSaga() {
  yield all([targetKpiSaga(), userTargetSaga()]);
}

// 리듀서 통합
const targetModule = combineReducers({
  targetKpi,
  userTarget,
});

export default targetModule;
